import { createFileRoute } from '@tanstack/react-router';

import { getAppDataOptions } from 'hooks/data/useAppData';

export const Route = createFileRoute('/_auth/_buttonView/_layout/training/_app/$id/_content')({
  loader: async ({ context, params }) => {
    const { queryClient } = context;

    const app = await queryClient.ensureQueryData(getAppDataOptions({ id: params.id }));

    context.title = app?.nameOnDevice ?? 'Unknown';

    return { app };
  },
});
